import { gql } from '@apollo/client';

const FACILITY_DETAIL_FRAGMENT = gql`
  fragment FacilityDetailFragment on Facility {
    id
    name
    contact {
      address
      city
      state
      country
      zip
      phone1
    }
    notificationEmail
  }
`;
export default FACILITY_DETAIL_FRAGMENT;
